import React from "react";
import clsx from "clsx";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { makeStyles, fade, darken, lighten } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useIntl } from 'react-intl';
import DateInput from './date-input';
import DateRangePicker from "./date-range-picker";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
  header: {
    borderBottom: '1px solid #DADCE0'
  },
  footer: {
    borderTop: '1px solid #DADCE0'
  },
  button: {
    textTransform: 'inherit',
    padding: '5px 25px',
    fontSize: 16,
    borderRadius: 10
  },
  activeButton: {
    backgroundColor: '#2592EA',
    color: '#fff',
    '&:hover': {
      backgroundColor: fade('#2592EA', 0.5),
    }
  },
  disabledButton: {
    backgroundColor: '#E0E0E0'
  },
  icon: {
    // backgroundColor: '#fff',
    color: darken('#E0E0E0', 0.5),
    // fontSize: 20,
    '&:hover': {
      color: '#fff',
      backgroundColor: '#BEBEBE',
      cursor: 'pointer',
      borderRadius: 20
    }
  },
  reset: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  refreshIcon: {
    color: lighten('#000', 0.5),
    fontSize: 18,
    marginRight: 5
  },
  calander: {
    boxShadow: '0px 0px 5px 5px rgba(169, 169, 169, 0.2)'
  },
  error: {
    fontSize: 14,
    color: 'red',
    fontWeight: 300
  }
});
const Dialog = ({ error, onClick, start, end, formatDate, onChange, open, onSubmit, onCancel, onInputChange, onClose, init, onInit, language }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Box display="flex" justifyContent="center" alignItems="flex-end" flexDirection="column" position="absolute" right="5%">
        <Box bgcolor="#fff" borderRadius={5} className={classes.calander}>
          {/* Header */}
          <Box display="flex" flexDirection="column" alignItems="flex-end" p={0.5}>
            <CloseIcon className={classes.icon} onClick={onClose} />
          </Box>
          <Box px={1} className={classes.header}>
              <Box display="flex"  justifyContent="space-between" pb={1}>
                <DateInput
                    value={!init && start}
                    formatDate={formatDate}
                    placeholder="Start Date"
                    active={open && !start}
                    inputName="start"
                    onChange={onInputChange}
                    language={language}
                    first
                />
                <DateInput
                    value={!init && end}
                    formatDate={formatDate}
                    placeholder="End Date"
                    active={start}
                    onChange={onInputChange}
                    inputName="end"
                    language={language}
                />
              </Box>
              { error &&
                  <Box display="flex" justifyContent="center" pt={0.5}>
                      <Typography className={classes.error}>
                        {error} 
                      </Typography>
                  </Box>
              }
            </Box>
            
          {/* Body */}
          <Box display="flex" justifyContent="center">
            <DateRangePicker
              variant="static"
              disableToolbar
              disableFuture
              value={[]}
              open={open}
              init={init}
              onChange={onChange}
              onClick={onClick}
              onInit={onInit}
            />
          </Box>

          {/* Footer */}
          <Box 
            className={classes.footer} 
            p={1}
            alignItems="center"
            display="flex" 
            alignSelf="stretch"
            justifyContent="space-between">
                <Button 
                  onClick={onCancel}
                  className={clsx(classes.button, classes.reset)}>
                    <RefreshIcon className={classes.refreshIcon}/>
                    {formatMessage({id:"app.reset", defaultMessage:"Reset"})}
                </Button>
                <Button
                  onClick={onSubmit} 
                  className={clsx(
                    classes.button, 
                    !start || !end? classes.disabledButton: classes.activeButton
                  )}
                  disabled={!start || !end}
                >
                    {formatMessage({id:"app.apply", defaultMessage:"Apply"})}
                </Button>
          </Box>

          </Box>
      </Box>
  );
}

export default Dialog;
